/* eslint-disable jsx-a11y/anchor-has-content,react/no-danger */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {filterUrl, filterYitmMobileContent, isInternalLink} from "../../helpers/filters";
import IconArrowSVG from '../../../public/images/global/icon__arrow.svg';

const GET_COMPONENT = gql`
query paragraphRevisionById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphMobileComponentNewsItemList {
          fieldNewsItems {
            ... on FieldParagraphFieldNewsItems {
              entity {
                ... on ParagraphInnerNewsItem {
                  fieldTxtHeadline
                  fieldTxtSubTitle
                  fieldExcerptIntro
                  fieldLink {
                    url {
                      path
                      routed
                    }
                    title
                  }
                  fieldObjectImgMedia {
                      entity {
                        ... on MediaImage {
                          fieldMediaImage {
                            width
                            height
                            url
                            alt
                            title
                          }
                        }
                      }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

class MobileComponentNewsItemList extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        markComponentLoadedAs: PropTypes.func.isRequired,
    };

    static defaultProps = {
        componentIndex: null
    };

    render() {
        const {id, markComponentLoadedAs} = this.props;

        return (
            <Query asyncMode query={GET_COMPONENT} variables={{ id }}>
                {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) {
                        markComponentLoadedAs(id, true);
                        return <div>{error}</div>;
                    }

                    const field = data.paragraphById;
                    const newsItems = field.fieldNewsItems && field.fieldNewsItems.length ? field.fieldNewsItems.map(component => component.entity) : [];

                    markComponentLoadedAs(id, true);

                    if (!newsItems.length) return null;

                    return (
                        <React.Fragment>
                            {newsItems.map(newsItem => (
                                <article className="yitm__splitArticle">
                                    <div className="container">
                                        <div className="yitm__splitArticleText">
                                            {newsItem.fieldTxtHeadline ? (<h3 className="yitm__splitArticleTitle">{newsItem.fieldTxtHeadline}</h3>) : null}
                                            {newsItem.fieldTxtSubTitle ? (<p className="yitm__splitArticleByline" dangerouslySetInnerHTML={{__html: filterYitmMobileContent(newsItem.fieldTxtSubTitle)}}/>) : null}
                                            {newsItem.fieldExcerptIntro ? (<p className="yitm__splitArticleExcerpt" dangerouslySetInnerHTML={{__html: filterYitmMobileContent(newsItem.fieldExcerptIntro)}}/>) : null}
                                            {newsItem.fieldLink && newsItem.fieldLink.url && newsItem.fieldLink.url.path ? (
                                                <a className={`yitm__splitArticleCta${(newsItem.fieldLink.url.path && !newsItem.fieldLink.url.path.includes('.pdf')) ? ' button' : ''}`}
                                                target={isInternalLink(newsItem.fieldLink.url.path) ? '_self' : '_blank'}
                                                   rel={isInternalLink(newsItem.fieldLink.url.path) ? null : 'noopener noreferrer'}
                                                   href={filterUrl(newsItem.fieldLink.url.path)}>
                                                    {newsItem.fieldLink.title} {} <IconArrowSVG/>
                                                </a>
                                            ) : null}
                                        </div>
                                        {newsItem.fieldObjectImgMedia && newsItem.fieldObjectImgMedia.entity && newsItem.fieldObjectImgMedia.entity.fieldMediaImage && newsItem.fieldObjectImgMedia.entity.fieldMediaImage.url ? (
                                            <div className="yitm__splitArticleImage">
                                                {newsItem.fieldLink && newsItem.fieldLink.url && newsItem.fieldLink.url.path ? (
                                                    <a className="yitm__splitArticleImageCta"
                                                       target={isInternalLink(newsItem.fieldLink.url.path) ? '_self' : '_blank'}
                                                       rel={isInternalLink(newsItem.fieldLink.url.path) ? null : 'noopener noreferrer'}
                                                       href={filterUrl(newsItem.fieldLink.url.path)}>
                                                        <img src={newsItem.fieldObjectImgMedia.entity.fieldMediaImage.url} alt={newsItem.fieldObjectImgMedia.entity.fieldMediaImage.alt}/>
                                                            {newsItem.fieldLink && newsItem.fieldLink.url && newsItem.fieldLink.url.path && newsItem.fieldLink.url.path.includes('.pdf') ? (
                                                                <span className="yitm__splitArticleImageIcon"><span className="fal fa-arrow-to-bottom" aria-hidden="true"/></span>
                                                            ) : null}
                                                    </a>
                                                ) :
                                                    <img src={newsItem.fieldObjectImgMedia.entity.fieldMediaImage.url} alt={newsItem.fieldObjectImgMedia.entity.fieldMediaImage.alt}/>
                                                }

                                            </div>
                                        ) : null}

                                    </div>
                                </article>
                            ))}
                        </React.Fragment>
                    );
                }}
            </Query>
        )
    }

}


export default MobileComponentNewsItemList;



// WEBPACK FOOTER //
// ./frontend/components/YITMMobile/MobileComponentNewsItemList.jsx